export enum PlayerQueryKeys {
	GetPlayerList = 'player.getPlayerList',
	GetChannelList = 'player.getChannelList',
	GetBannedPlayerList = 'player.getBannedPlayerList',
	GetInactivePlayerList = 'player.getInactivePlayerList',
	GetMinimumWithdrawSetting = 'player.getMinimumWithdrawSetting',
	ClearTurnoverHistory = 'player.clearTurnoverHistory',
	GetPlayerTransactionsById = 'player.getPlayerTransactionsById',
	GetPlayerPlaylog = 'player.getPlayerPlaylog',
	GetReferredPlayers = 'player.getReferredPlayers',
	GetPlayerCumulative = 'player.getPlayerCumulative',
	GetPlayerDetail = 'player.getPlayerDetail',
	GetActivePlayer = 'player.getActivePlayer',
	GetPlayerWithDeposit = 'player.getPlayerWithDeposit',
	GetPlayerWithDepositPromotion = 'player.getPlayerWithDepositPromotion',
	GetPlayerWithDepositsWithoutPromotion = 'player.getPlayerWithDepositsWithoutPromotion',
	GetPlayerActivityLog = 'player.getPlayerActivityLog',
	GetPlayerWithWithdraw = 'player.getPlayerWithWithdraw',
	GetPlayerWithLuckyWheelReceive = 'player.getPlayerWithLuckyWheelReceive',
	GetPlayerWithReturnLossReceive = 'player.getPlayerWithReturnLossReceive',
	GetPlayerWithDailyCheckInReceive = 'player.getPlayerWithDailyCheckInReceive',
	GetPlayerDataList = 'player.getPlayerDataList',
	GetRegisteredPlayerList = 'player.getRegisteredPlayerList',
	GetInviteFriendTierCounts = 'player.getInviteFriendTierCounts',
	GetInviteFriendReferredPlayers = 'player.getInviteFriendReferredPlayers',
	GetPlayerProviderStats = 'player.getPlayerProviderStats',
	GetPlayerFullPhone = 'player.getPlayerFullPhone',
	GetPlayerCommission = 'player.getPlayerCommission',
	GetPlayerReturnLoss = 'player.getPlayerReturnLoss',
}

export enum PlayerMutationKeys {
	CreatePlayer = 'player.createPlayer',
	UpdatePlayer = 'player.updatePlayer',
	DeletePlayer = 'player.deletePlayer',
	CreateChannel = 'player.createChannel',
	UpdateChannel = 'player.updateChannel',
	DeleteChannel = 'player.deleteChannel',
	UpdateMinimumWithdrawSetting = 'player.updateMinimumWithdrawSetting',
	ClearPlayerLockout = 'player.clearPlayerLockout',
	ClearPlayerTurnover = 'player.clearPlayerTurnover',
	ClearPlayerMainWalletTurnover = 'player.clearPlayerMainWalletTurnover',
	UpdatePlayerMainWalletBalance = 'player.updatePlayerMainWalletBalance',
	ReinitPlaylog = 'player.reinitPlaylog',
	ToggleDemoAccount = 'player.toggleDemoAccount',
}

export enum PartnerQueryKeys {
	GetPartners = 'get.partners',
	GetPartnerById = 'get.partnerById',
	GetPartnerPlayers = 'get.partnerPlayers',
	GetPartnerPlayersSummary = 'get.partnerPlayersSummary',
	GetPartnerPaymentRecords = 'get.partnerPaymentRecords',
	GetPartnerPaymentRecordById = 'get.partnerPaymentRecordById',
	GetAdminPartnerDailyTransactions = 'get.adminPartnerDailyTransactions',
	GetAdminPartnerInvitationSummary = 'get.adminPartnerInvitationSummary',
}

export enum PartnerMutationKeys {
	CreatePartner = 'create.partner',
	UpdatePartner = 'update.partner',
	DeletePartner = 'delete.partner',
	ExportPartnerPlayersCsv = 'export.partnerPlayersCsv',
	AddCreditToPartner = 'add.creditToPartner',
	CreatePartnerPaymentRecord = 'create.partnerPaymentRecord',
}

export const PLAYER_DATA_LIST = 'PLAYER_DATA_LIST'
